module.exports = __webpack_public_path__ + "static/media/RosaSamanthaMoralesGonzalez.4650ddac.jpg";